export function extractFromMultiName(s?: string, defaultName = ""): string {
  return s?.split("\n")?.[0] ?? defaultName;
}

export function isUuid(str: string): boolean {
  const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
  return regex.test(str);
}

export function extractFromMultiNameList(nameArrays: string[] | string): string {
  if (!nameArrays) return "";

  // Normalize to array
  const names = Array.isArray(nameArrays) ? nameArrays : [nameArrays];

  // Remove duplicates, filter out falsy values (null, undefined, empty)
  return Array.from(new Set(names.filter(Boolean))).join(", ");
}

export function getEarliestDate(dates: string[] | string): string {
  if (!dates) return "";

  const dateArray = Array.isArray(dates) ? dates : [dates];

  if (dateArray.length === 0) return "";

  return dateArray.reduce((earliest, current) => (new Date(current) < new Date(earliest) ? current : earliest));
}

export function getLatestDate(dates: string[] | string): string {
  if (!dates) return "";

  const dateArray = Array.isArray(dates) ? dates : [dates];

  if (dateArray.length === 0) return "";

  return dateArray.reduce((latest, current) => (new Date(current) > new Date(latest) ? current : latest));
}
